export default __webpack_public_path__ + "static/ferrari-aa5aec093a586a26f187bb22cf20dc0e.webp";